import React from 'react';
import { useNavigate } from 'react-router-dom';

function CardPServicio({ servicio }) {
  const navigate = useNavigate();

    const handleRedirect = (servicio) => {
        navigate(`/detalle/${servicio.codigo}`, {state:{servicio:servicio}})
    }
  return (
    <button 
      onClick={() => handleRedirect(servicio)} 
      className='h-40 w-80 m-2 bg-Blanco flex flex-col shadow-cardsuave rounded-lg'
    >
      <div className='flex flex-row h-full rounded-lg overflow-hidden'>
        {/* Imagen del servicio a la izquierda */}
        <div className='w-full h-full'>
          <img 
            src={servicio.imagen} 
            className='w-full h-full object-cover' 
            alt='img-servicio' 
          />
        </div>
        {/* Descripción del servicio a la derecha */}
        <div className='flex-grow flex flex-col justify-between p-2'>
          <p className='text-base text-GrisOscuro line-clamp-3'>
            {servicio.descripcion}
          </p>
          <div className='flex justify-center'>
          <label className='font-bold'>
  AR${Number(servicio.preciopeso).toLocaleString('es-AR')}
</label>

          </div>
        </div>
      </div>
    </button>
  );
}

export default CardPServicio;
